import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';

@Component({
  selector: 'app-venodr-with-max-closed-industry',
  templateUrl: './venodr-with-max-closed-industry.component.html',
  styleUrls: ['./venodr-with-max-closed-industry.component.css']
})
export class VenodrWithMaxClosedIndustryComponent implements OnInit {

  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  route:string;
  industryList = [];
  industryListLoader = false;

  userData:any = [];
  userName = null;
  userLevel = null;
  public state: string = environment.state;
  
  ngOnInit() {

    this.userData = JSON.parse(localStorage.getItem('userData'));
    if(this.userData){
      this.userName = this.userData['user_profile_id'];
      this.userLevel = this.userData['access_level'];
    }
    this.getIndustryList();
  }

  getIndustryList(){

    this.industryListLoader = true;
    this.route  = 'get-vendor-with-max-closed-industry';
    const token = localStorage.getItem('userToken');
    let data = {'user_id':this.userName,'user_level':this.userLevel};

    this._service.postRequestCreator(data, this.route, token).subscribe((response: any) => {

      if(response.status == 204) {
        localStorage.removeItem('userToken');
        localStorage.removeItem('userData');
        this.router.navigate(['login']);
      }

      if(response.status == 200){
        this.industryList = response.data;
      }
      this.industryListLoader = false;
    });

  }
}
